import { ChatOutlineIcon } from './ChatOutlineIcon';

/**
 * author: Michael Richins
 * id E6394813-3C45-4D08-A207-9008A2E5CECB
 * name chat-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chat-outline.svg
 * tags
 */
export const MessageBubbleOutlineIcon = ChatOutlineIcon;
export default MessageBubbleOutlineIcon